<div class="json-preview-dialog">
    <div class="dialog-header">
        <div class="header-left">
            <mat-icon class="header-icon">data_object</mat-icon>
            <h2>AWS SES Template JSON</h2>
        </div>
        <div class="header-actions">
            <button class="btn-copy" (click)="copyToClipboard()" matTooltip="Copy JSON">
                <mat-icon>content_copy</mat-icon>
            </button>
            <button class="btn-close" (click)="dialogRef.close()" matTooltip="Close">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <div class="template-info">
        <span class="template-name">{{ data.templateName }}</span>
        <div class="language-tabs">
            <button *ngFor="let lang of languages"
                    class="lang-tab" [class.active]="selectedLang === lang"
                    (click)="selectLanguage(lang)">
                {{ lang | uppercase }}
            </button>
        </div>
    </div>

    <div class="json-container">
        <pre class="json-content"><code>{{ formattedJson }}</code></pre>
    </div>
</div>
